import calAnimation from "@assets/images/Calc_Animation.gif";
import { Dialog, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        borderRadius: 16
      },
      width: "400px",
      padding: "32px 24px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      borderRadius: "4px",
      gap: "24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    icon: {
      width: "40px"
    },
    text: {
      fontWeight: 700,
      fontSize: "20px",
      lineHeight: "26px"
    }
  }),
  { name: "PriceDialogProcessing" }
);

interface PriceDialogProcessingProps {
  open: boolean;
  onClose?: () => void;
  description?: string;
}

const PriceDialogProcessing: React.FC<PriceDialogProcessingProps> = ({
  open,
  onClose,
  description
}) => {
  const classes = useStyles();
  return (
    <Dialog open={open} onClose={onClose}>
      <Paper className={classes.root}>
        <img src={calAnimation} alt="" className={classes.icon} />
        <MyTypography variant="body2" className={classes.text}>
          {description
            ? description
            : "ระบบกำลังประมวลผลคำสั่งซื้อ กรุณารอสักครู่"}
        </MyTypography>
      </Paper>
    </Dialog>
  );
};

export default PriceDialogProcessing;
